export default "__VITE_ASSET__C040h1Vq__"